module.exports = __webpack_public_path__ + "media/images/pages/who_we_are/team-8-8da2dcbe6f05321336c063fe5360872c.png";